import { BrowserModule, REMOVE_STYLES_ON_COMPONENT_DESTROY } from '@angular/platform-browser';
import { APP_INITIALIZER, ChangeDetectorRef, NgModule } from '@angular/core';
import { KeycloakService } from './services/keycloak.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { MapComponent } from './map/map.component';
import { MenuComponent } from './menu/menu.component';
import { FooterComponent } from './footer/footer.component';
import { CalculationControlComponent } from './map/calculation-control/calculation-control.component';
import { HttpClientModule } from '@angular/common/http';
import { ToolsControlComponent } from './map/tools-control/tools-control.component';
import { ProjectsControlComponent } from './map/projects-control/projects-control.component';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalMessageComponent } from './utils/modals/modal-message/modal-message.component';
import { ModalModule,BsModalRef } from 'ngx-bootstrap/modal';
import { BlockUIModule } from 'ng-block-ui';
import { AddSectorizationsComponent } from './footer/add-sectorizations/add-sectorizations.component';
import { CoordinatePointsComponent } from './footer/coordinate-points/coordinate-points.component';
import { NavaidsComponent } from './footer/navaids/navaids.component';
import { CalculationProceduresComponent } from './footer/calculation-procedures/calculation-procedures.component';
import { AddNavaidAnglesComponent } from './footer/add-navaid-angles/add-navaid-angles.component';
import { AddProjectControlComponent } from './footer/add-project-control/add-project-control.component';
import { ModalConfirmationMessageComponent } from './utils/modals/modal-confirmation-message/modal-confirmation-message.component';
import { CreateProjectComponent } from './popup/create-project/create-project.component';
import { PopupConfigurationTerrainComponent } from './popup/configuration-terrain/configuration-terrain.component';
import { CoordenatesControlComponent } from './map/coordenates-control/coordenates-control.component';
import { ConfigurationMenuComponent } from './menu/configuration-menu/configuration-menu.component';
import { ImportMenuComponent } from './menu/import-menu/import-menu.component';
import { ExportMenuComponent } from './menu/export-menu/export-menu.component';
import { ViewMenuComponent } from './menu/view-menu/view-menu.component';
import { DatabaseMenuComponent } from './menu/database-menu/database-menu.component';
import { CalculationMenuComponent } from './menu/calculation-menu/calculation-menu.component';
import { ToolsMenuComponent } from './menu/tools-menu/tools-menu.component';
import { HelpMenuComponent } from './menu/help-menu/help-menu.component';
import { PopupConfigurationLayerComponent } from './popup/configuration-layer/configuration-layer.component';
import { ValidationModalComponent } from './popup/validation-modal/validation-modal.component';
import { PopupAreaCoverageComponent } from './popup/calculations/area-coverage/area-coverage.component';
import { SearchControlComponent } from './map/search-control/search-control.component';

import { PopupPerformanceAnalysisComponent } from './popup/calculations/performance-analysis/performance-analysis.component';
import { PopupPerformanceCalculationComponent } from './popup/calculations/performance-calculation/performance-calculation.component';
import { ImportComponent } from './popup/import/import/import.component';
import { ExportComponent } from './popup/export/export.component';
import { ConfigurationManagerComponent } from './popup/configurations/configuration-manager/configuration-manager.component';
import { TerrainsComponent } from './popup/configurations/terrains/terrains.component';
import { CalculationComponent } from './popup/configurations/calculation/calculation.component';
import { RnavComponent } from './popup/configurations/rnav/rnav.component';
import { ProcedureComponent } from './popup/configurations/procedure/procedure.component';
import { DefaultAltitudesComponent } from './popup/configurations/default-altitudes/default-altitudes.component';
import { RcsComponent } from './popup/configurations/rcs/rcs.component';
import { LayersComponent } from './popup/configurations/layers/layers.component';
import { ShortcutsComponent } from './map/shortcuts/shortcuts.component';
import { GlobalSelectionComponent } from './map/global-selection/global-selection.component';
import { SupportTicketShortcutComponent } from './map/support-ticket-shortcut/support-ticket-shortcut.component';
import { PrintMapComponent } from './popup/print-map/print-map.component';
import { GenericComponent } from './popup/generic/generic.component';
import { ProceduresComponent } from './footer/procedures/procedures.component';
import { AirspaceBoundariesComponent } from './footer/airspace-boundaries/airspace-boundaries.component';
import { GenericWindowComponent } from './footer/generic-window/generic-window.component';
import { ShortcutsManagementComponent } from './popup/shortcuts-management/shortcuts-management.component';
import { CreateNavaidFromMapComponent } from './footer/navaids/create-navaid-from-map/create-navaid-from-map.component';
import { SelectCoordinatePointComponent } from './popup/select-coordinate-point/select-coordinate-point.component';
import { CoordinatesComponent } from './popup/coordinates/coordinates.component';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import { RouteSegmentsCsvComponent } from './popup/import/route-segments-csv/route-segments-csv.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgxCsvParserModule } from 'ngx-csv-parser';
import { DynamicTable } from './popup/dynamic-table/dynamic-table.component';
// import { MatTableModule } from '@angular/material/table';
import { CdkTableModule } from '@angular/cdk/table';
import { SortPipe } from './utils/pipes/sort.pipe';
import { AnnotationComponent } from './popup/annotation/annotation.component';
import { CreateProcedureFromRouteSegmentComponent } from './popup/create-procedure-from-route-segment/create-procedure-from-route-segment.component';
import { AreaComponent } from './popup/area/area.component';
import { NavaidsCsvComponent } from './popup/import/navaids-csv/navaids-csv.component';
import { ProceduresCsvComponent } from './popup/import/procedures-csv/procedures-csv.component';
import { ProcedureNavaidAssociationComponent } from './footer/procedure-navaid-association/procedure-navaid-association.component';
import { FomCheckComponent } from './footer/fom-check/fom-check.component';
import { DisplayComponent } from './popup/configurations/display/display.component';
import { NavaidSitingToolComponent } from './popup/calculations/navaid-siting-tool/navaid-siting-tool.component';
import { ScaleControlComponent } from './map/scale-control/scale-control.component';
import { ProjectManagementControlComponent } from './popup/configurations/project-management-control/project-management-control.component';
import { MtboValidationDirective } from './directives/mtbo-validation.directive';
import { NavaidsFilterComponent } from './footer/navaids-filter/navaids-filter.component';
import { ProceduresFilterComponent } from './footer/procedures-filter/procedures-filter.component';
import { CoordinatePointsFilterComponent } from './footer/coordinate-points-filter/coordinate-points-filter.component';
import { MaterialModel } from '../material.model';
import { ProcedureVerticalProfileComponent } from './popup/calculations/procedure-vertical-profile/procedure-vertical-profile.component';
import { PreProcessingToolComponent } from './popup/tools/flight-inspection/pre-processing-tool/pre-processing-tool.component';
import { ObstacleDataCsvComponent } from './popup/import/obstacle-data-csv/obstacle-data-csv/obstacle-data-csv.component';
import { AltitudeFilterComponent } from './footer/altitude-filter/altitude-filter/altitude-filter.component';
import { TerrainGridComponent } from './footer/terrain-grid/terrain-grid.component';
import { NavaidStatusComponent } from './popup/import/navaid-status/navaid-status.component';
import { AzimuthToolComponent } from './footer/azimuth-tool/azimuth-tool.component';
import { AirspaceBoundariesFilterComponent } from './footer/airspace-boundaries-filter/airspace-boundaries-filter.component';
import { ProcedureAssessmentsComponent } from './footer/procedure-assessments/procedure-assessments.component';
import { TerrainAltitudeCutComponent } from './popup/tools/terrain-altitude-cut/terrain-altitude-cut.component';
import { HorizonToolComponent } from './footer/horizon-tool/horizon-tool.component';
import { MapSearchComponent } from './footer/map-search/map-search.component';
import { MultipathToolComponent } from './footer/multipath-tool/multipath-tool.component';
import { BarometricCalculationComponent } from './footer/barometric-calculation/barometric-calculation.component';
import { CoverageAssessmentComponent } from './popup/tools/coverage-assessment/coverage-assessment.component';
import { FlightInspectionComponent } from './popup/import/flight-inspection/flight-inspection.component';
import { TrajectoriesRvtKmzComponent } from './popup/import/trajectories-rvt-kmz/trajectories-rvt-kmz.component';
import { AirspaceVertexComponent } from './popup/import/airspace-vertex/airspace-vertex.component';
import { DistanceAzimuthComponent } from './map/distance-azimuth/distance-azimuth.component';
import { DirectoriesComponent } from './popup/configurations/directories/directories.component';
import { NetworkComponent } from './popup/configurations/network/network.component';
import { FacilityComponent } from './popup/configurations/facility/facility.component';
import { CoverageQuantitativeAssessmentComponent } from './popup/calculations/coverage-quantitative-assessment/coverage-quantitative-assessment.component';
import { CoverageQuantitativeAssessmentResultComponent } from './footer/coverage-quantitative-assessment-result/coverage-quantitative-assessment-result.component';
import { PerformanceReportComponent } from './footer/performance-report/performance-report.component';
import { SectorizationDisplayComponent } from './popup/sectorization-display/sectorization-display/sectorization-display.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { RangeRingToolComponent } from './footer/range-ring-tool/range-ring-tool/range-ring-tool.component';
import { TrajetcoryComponent } from './footer/trajetcory/trajetcory.component';
import { TrajetcoryRvtKmzComponent } from './popup/import/trajetcory-rvt-kmz/trajetcory-rvt-kmz.component';
import { TrajetcoryFilterComponent } from './footer/trajetcory-filter/trajetcory-filter.component';
import { SaveProcedureAssessmentComponent } from './popup/save-procedure-assessment/save-procedure-assessment.component';
import { GenerateReportComponent } from './popup/generate-report/generate-report.component';
import { MapPreviewComponent } from './popup/map-preview/map-preview.component';
import { CalculationResultsComponent } from './menu/calculation-results/calculation-results.component';
import { DuplicateNavaidsComponent } from './popup/import/duplicate-navaids/duplicate-navaids.component';
import { DuplicationCheckComponent } from './popup/duplication-check/duplication-check.component';
import { DuplicationCheckOptionsComponent } from './popup/duplication-check-options/duplication-check-options.component';
import { CrossSectionComponent } from './footer/cross-section/cross-section/cross-section.component';
import { TabsComponent } from './footer/tabs/tabs.component';
import { CoordPointDuplicationCheckComponent } from './popup/coord-point-duplication-check/coord-point-duplication-check.component';
import { CoordPointDuplicationWarningComponent } from './popup/coord-point-duplication-warning/coord-point-duplication-warning.component';
import { NavaidsCoChannelsComponent } from './footer/navaids-co-channels/navaids-co-channels.component';
import { Draw8dbBoundaryComponent } from './popup/draw8db-boundary/draw8db-boundary.component';
import { NewLayersComponent } from './menu/new-layers/new-layers.component';
import { FrequencyCorrectedNavaidsComponent } from './popup/import/frequency-corrected-navaids/frequency-corrected-navaids.component';
import { VertexTypeSelectionComponent } from './popup/import/vertex-type-selection/vertex-type-selection.component';
import { SAAMtraficImportComponent } from './popup/saamtrafic-import/saamtrafic-import.component';
import { SaamTrafficFilterComponent } from './footer/saam-traffic-filter/saam-traffic-filter.component';
import { ProceduresNmAixm51Component } from './popup/import/procedures-nm-aixm51/procedures-nm-aixm51.component';
import { ConfigureFlightInpectionFormatComponent } from './popup/configure-flight-inpection-format/configure-flight-inpection-format.component';
import { FlightInspectionStyleComponent } from './popup/flight-inspection-style/flight-inspection-style.component';
import { RoutesegmentTypeSelectionComponent } from './popup/import/routesegment-type-selection/routesegment-type-selection.component';
import { RouteSegmentsXmlComponent } from './popup/import/route-segments-xml/route-segments-xml.component';
import { CoordpointidStatusComponent } from './popup/import/coordpointid-status/coordpointid-status.component';
import { ProcedureTypeSelectionComponent } from './popup/import/procedure-type-selection/procedure-type-selection.component';
import { ConfigurationColorSettingsComponent } from './popup/configuration-color-settings/configuration-color-settings.component';
import { ColorGradientCumulativeCoverageComponent } from './popup/color-gradient-cumulative-coverage/color-gradient-cumulative-coverage.component';

import { ConfigureProcessingToolFormatComponent } from './popup/configure-processing-tool-format/configure-processing-tool-format.component';
import { TerrainHeightComponent } from './map/terrain-height/terrain-height.component';
import { ProcessingToolOptionsComponent } from './popup/processing-tool-options/processing-tool-options.component';
import { ExportProcessingToolComponent } from './popup/export-processing-tool/export-processing-tool.component';
import { SingleTextInputModalComponent } from './utils/modals/single-text-input-modal/single-text-input-modal.component';
import { ImportUserLayerComponent } from './popup/import-user-layer/import-user-layer.component';
import { StyleEditorComponent } from './popup/style-editor/style-editor.component';
import { ChangeTransparencyComponent } from './popup/change-transparency/change-transparency.component';
import { CoverageColorPickerComponent } from './popup/coverage-color-picker/coverage-color-picker.component';
import { UserSpaceComponent } from './popup/configurations/user-space/user-space.component';
import { AnalysisToolComponent } from './footer/analysis-tool/analysis-tool.component';
import { ForbiddenSubstringValidatorDirective } from './data-validation/forbidden-name.directive';
import { AlphaNumericValidatorDirective } from './data-validation/alphaNumeric.directive';
import { CalculationConfigurationComponent } from './footer/calculation-configuration/calculation-configuration.component';
import { ReadMeComponent } from './popup/read-me/read-me.component';
import { ContextualHelpComponent } from './popup/contextual-help/contextual-help.component';
import { CreateOrEditContextualHelpComponent } from './popup/create-or-edit-contextual-help/create-or-edit-contextual-help.component';
import { SatPopoverModule } from '@ncstate/sat-popover';
import { MenuOptionComponent } from './menu/menu-option/menu-option.component';
import { SelfTrainingToolComponent } from './footer/self-training-tool/self-training-tool.component';
import { ErrorLogsDisplayComponent } from './popup/error-logs-display/error-logs-display.component';
import { SelectAntennaPatternComponent } from './popup/select-antenna-pattern/select-antenna-pattern.component';
import { NavaidAntennaModelAssociationComponent } from './popup/navaid-antenna-model-association/navaid-antenna-model-association.component';
import { AddAntennaModelComponent } from './popup/add-antenna-model/add-antenna-model.component';
import { SelectByFirComponent } from './popup/select-by-fir/select-by-fir.component';
import { loginRequest, msalConfig } from './auth-config';
import { IPublicClientApplication, PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MsalModule, MsalService, MsalGuard, MsalBroadcastService, MSAL_INSTANCE, MsalGuardConfiguration, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { UserApprovalComponent } from './popup/user-approval/user-approval.component';
import { environment } from 'src/environments/environment';

//#region GRIT
import { AccessDirective } from "./directives/access.directive";
import { DeviceComponent } from './footer/grit/device/device.component';
import { ReceiverComponent } from './footer/grit/receiver/receiver.component';
import { EditableDirective } from './directives/editable.directive';
import { InterferenceTestComponent } from './footer/grit/interference-test/interference-test.component';
import { RadarComponent } from './footer/grit/radar/radar.component';
import { FeatureFilterComponent } from './footer/grit/feature-filter/feature-filter.component';
import { ImpactCalculationComponent } from './popup/grit/impact-calculation/impact-calculation.component';
import { SelectFeaturesComponent } from './popup/grit/select-features/select-features.component';
import { MatTableModule } from "@angular/material/table";
import { GritDynamicTableComponent } from "./utils/grit/grit-dynamic-table/grit-dynamic-table.component";
import { AddDeviceSectorizationComponent } from './popup/grit/add-device-sectorization/add-device-sectorization.component';
import { InterferenceTestDeviceComponent } from './footer/grit/interference-test-device/interference-test-device.component';
import {
  GritDynamicTableFeaturesComponent
} from "./utils/grit/grit-dynamic-table-features/grit-dynamic-table-features.component";
import { UserMenuComponent } from './menu/user-menu/user-menu.component';
import { SubscriptionListComponent } from './popup/grit/subscription-list/subscription-list.component';
import { MailingListComponent } from './popup/grit/mailing-list/mailing-list.component';
import { GritNotamComponent } from "./utils/grit/grit-notam/grit-notam.component";
import { MatSelectModule } from "@angular/material/select";
import { SendNotamComponent } from './popup/grit/send-notam/send-notam.component';
import { GritGroupsComponent } from "./utils/grit/grit-groups/grit-groups.component";

import { NgxSliderModule } from '@angular-slider/ngx-slider';
//endregion
import { UserManagementComponent } from './popup/user-management/user-management.component';
import { UserProfileComponent } from './popup/user-profile/user-profile.component';
import { UserSupportTicketComponent } from './popup/user-support-ticket/user-support-ticket.component';
import { SupportTicketsComponent } from './popup/support-tickets/support-tickets.component';
import { AccessDeniedInterceptor } from './interceptors/access-denied.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { GdprConsentComponent } from './popup/gdpr-consent/gdpr-consent.component';
import { provideZoneChangeDetection } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { TerrainWatermarkComponent } from "./terrain-watermark/terrain-watermark.component";

/**
 * Here we pass the configuration parameters to create an MSAL instance.
 * For more info, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-angular/docs/v2-docs/configuration.md
 */
export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication(msalConfig);
}

/**
 * Set your default interaction type for MSALGuard here. If you have any
 * additional scopes you want the user to consent upon login, add them here as well.
 */
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: loginRequest
  };
}

export function initializeMsal(msalService: MsalService): () => Promise<void> {
  return async () => {
    await msalService.instance.initialize();
  };
}

// fake msal services to be used when environment.useB2cAuthentication is false. In order to prevent compilation errors
export class FakeMsalService {
  instance = { initialize: async () => { } };
}
export class FakeMsalBroadcastService {
  inProgress$ = { subscribe: () => { } };
}
export const FakeMsalGuardConfig: MsalGuardConfiguration = {
  interactionType: InteractionType.Redirect,
  authRequest: null,
};

export function initializeKeycloak(keycloakService: KeycloakService): () => Promise<void> {
  return () => keycloakService.init();
}

const keycloakProvider = environment.useKeycloakAuthentication
  ? [{
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      deps: [KeycloakService],
      multi: true
    }]
  : [];


const routes: Routes = [];
// Build the imports array
const appImports = [
    SatPopoverModule,
    BrowserModule,
    HttpClientModule,
    FormsModule,
    CommonModule,
    BrowserAnimationsModule,
    NgbModule,
    ModalModule.forRoot(),
    BlockUIModule.forRoot(),
    RouterModule.forRoot(routes),
    ReactiveFormsModule,
    ColorPickerModule,
    NgxCsvParserModule,
    CdkTableModule,
    AutocompleteLibModule,
    MaterialModel,
    ClipboardModule,
    MatTableModule,
    GritDynamicTableComponent,
    GritDynamicTableFeaturesComponent,
    GritNotamComponent,
    MatSelectModule,
    GritGroupsComponent,
    NgxSliderModule,
];

if (environment.useB2cAuthentication) {
  appImports.push(MsalModule);
}

// Build the providers array
const appProvidersBase = environment.useB2cAuthentication
  ? [
      provideZoneChangeDetection(),

      {
        provide: MSAL_INSTANCE,
        useFactory: MSALInstanceFactory
      },
      {
        provide: MSAL_GUARD_CONFIG,
        useFactory: MSALGuardConfigFactory
      },
      {
        provide: APP_INITIALIZER,
        useFactory: initializeMsal,
        deps: [MsalService],
        multi: true
      },
      MsalService,
      MsalGuard,
      MsalBroadcastService,
      { provide: HTTP_INTERCEPTORS, useClass: AccessDeniedInterceptor, multi: true }

    ]
  : [
      provideZoneChangeDetection(),
      { provide: MsalService, useClass: FakeMsalService },
      { provide: MsalBroadcastService, useClass: FakeMsalBroadcastService },
      { provide: MSAL_GUARD_CONFIG, useValue: FakeMsalGuardConfig },
      { provide: REMOVE_STYLES_ON_COMPONENT_DESTROY, useValue: false },
      { provide: HTTP_INTERCEPTORS, useClass: AccessDeniedInterceptor, multi: true }
    ];

const appProviders = [
  ...appProvidersBase,
  ...keycloakProvider
];

@NgModule({
    declarations: [
        AppComponent,
        MapComponent,
        TerrainWatermarkComponent,
    MenuComponent,
        FooterComponent,
        CalculationControlComponent,
        ToolsControlComponent,
        ProjectsControlComponent,
        CoordenatesControlComponent,
        ModalMessageComponent,
        AddSectorizationsComponent,
        CoordinatePointsComponent,
        NavaidsComponent,
        CalculationProceduresComponent,
        AddNavaidAnglesComponent,
        AddProjectControlComponent,
        ModalConfirmationMessageComponent,
        CreateProjectComponent,
        PopupConfigurationLayerComponent,
        PopupConfigurationTerrainComponent,
        ConfigurationMenuComponent,
        ImportMenuComponent,
        ExportMenuComponent,
        ViewMenuComponent,
        DatabaseMenuComponent,
        CalculationMenuComponent,
        ToolsMenuComponent,
        HelpMenuComponent,
        ShortcutsComponent,
        ValidationModalComponent,
        PopupAreaCoverageComponent,
        PopupPerformanceAnalysisComponent,
        PopupPerformanceCalculationComponent,
        SearchControlComponent,
        ExportComponent,
        ImportComponent,
        ExportComponent,
        ConfigurationManagerComponent,
        TerrainsComponent,
        CalculationComponent,
        RnavComponent,
        ProcedureComponent,
        DefaultAltitudesComponent,
        RcsComponent,
        GlobalSelectionComponent,
        SupportTicketShortcutComponent,
    AirspaceBoundariesComponent,
        PrintMapComponent,
        GenericComponent,
        ProceduresComponent,
        GenericWindowComponent,
        ShortcutsManagementComponent,
        LayersComponent,
        CreateNavaidFromMapComponent,
        SelectCoordinatePointComponent,
        CoordinatesComponent,
        RouteSegmentsCsvComponent,
        DynamicTable,
        AnnotationComponent,
        SortPipe,
        CreateProcedureFromRouteSegmentComponent,
        AreaComponent,
        NavaidsCsvComponent,
        ProceduresCsvComponent,
        ProcedureNavaidAssociationComponent,
        FomCheckComponent,
        DisplayComponent,
        NavaidSitingToolComponent,
        ScaleControlComponent,
        ProjectManagementControlComponent,
        MtboValidationDirective,
        NavaidsFilterComponent,
        ProceduresFilterComponent,
        CoordinatePointsFilterComponent,
        ProcedureVerticalProfileComponent,
        PreProcessingToolComponent,
        ObstacleDataCsvComponent,
        AltitudeFilterComponent,
        TerrainGridComponent,
        NavaidStatusComponent,
        AirspaceBoundariesFilterComponent,
        AzimuthToolComponent,
        CoverageQuantitativeAssessmentComponent,
        CoverageQuantitativeAssessmentResultComponent,
        ProcedureAssessmentsComponent,
        TerrainAltitudeCutComponent,
        HorizonToolComponent,
        MapSearchComponent,
        MultipathToolComponent,
        BarometricCalculationComponent,
        CoverageAssessmentComponent,
        FlightInspectionComponent,
        TrajectoriesRvtKmzComponent,
        AirspaceVertexComponent,
        DistanceAzimuthComponent,
        DirectoriesComponent,
        FacilityComponent,
        PerformanceReportComponent,
        NetworkComponent,
        SectorizationDisplayComponent,
        RangeRingToolComponent,
        TrajetcoryComponent,
        TrajetcoryRvtKmzComponent,
        TrajetcoryFilterComponent,
        SaveProcedureAssessmentComponent,
        GenerateReportComponent,
        MapPreviewComponent,
        CalculationResultsComponent,
        DuplicateNavaidsComponent,
        DuplicationCheckComponent,
        DuplicationCheckOptionsComponent,
        CrossSectionComponent,
        TabsComponent,
        CoordPointDuplicationCheckComponent,
        CoordPointDuplicationWarningComponent,
        NewLayersComponent,
        NavaidsCoChannelsComponent,
        Draw8dbBoundaryComponent,
        FrequencyCorrectedNavaidsComponent,
        VertexTypeSelectionComponent,
        SAAMtraficImportComponent,
        SaamTrafficFilterComponent,
        ProceduresNmAixm51Component,
        ConfigureFlightInpectionFormatComponent,
        FlightInspectionStyleComponent,
        CoordpointidStatusComponent,
        ProcedureTypeSelectionComponent,
        RoutesegmentTypeSelectionComponent,
        RouteSegmentsXmlComponent,
        ConfigurationColorSettingsComponent,
        ColorGradientCumulativeCoverageComponent,
        ConfigureProcessingToolFormatComponent,
        TerrainHeightComponent,
        ProcessingToolOptionsComponent,
        ExportProcessingToolComponent,
        SingleTextInputModalComponent,
        ImportUserLayerComponent,
        StyleEditorComponent,
        ChangeTransparencyComponent,
        CoverageColorPickerComponent,
        UserSpaceComponent,
        AnalysisToolComponent,
        ForbiddenSubstringValidatorDirective,
        AlphaNumericValidatorDirective,
        CalculationConfigurationComponent,
        ReadMeComponent,
        ContextualHelpComponent,
        CreateOrEditContextualHelpComponent,
        MenuOptionComponent,
        SelfTrainingToolComponent,
        ErrorLogsDisplayComponent,

        //#region GRIT
        AccessDirective,
        ReceiverComponent,
        DeviceComponent,
        EditableDirective,
        InterferenceTestComponent,
        RadarComponent,
        FeatureFilterComponent,
        ImpactCalculationComponent,
        SelectFeaturesComponent,
        AddDeviceSectorizationComponent,
        InterferenceTestDeviceComponent,
        UserMenuComponent,
        SubscriptionListComponent,
        MailingListComponent,
        SendNotamComponent,
        //endregion
        SelectAntennaPatternComponent,
        NavaidAntennaModelAssociationComponent,
        AddAntennaModelComponent,
        ErrorLogsDisplayComponent,
        SelectByFirComponent,
        UserApprovalComponent,
        UserManagementComponent,
    UserProfileComponent,
    UserSupportTicketComponent,
    SupportTicketsComponent,
    GdprConsentComponent

  ],
  imports: appImports,
  providers: appProviders,
  bootstrap: [AppComponent]
})
export class AppModule { }
